__webpack_require__.p = "https://golantelecom.co.il/Spa/";